module.exports = __webpack_public_path__ + "img/wait.e97adef9.png";